import React from 'react';
import { Group, Image, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

const WorkspaceSwitcher = () => {
  return (
    <UnstyledButton
      aria-label="Station selector"
      style={{
        width: '100%',
        borderRadius: 10,
        backgroundColor: '#111827',
        border: '1px solid rgba(148, 163, 184, 0.2)',
        padding: '10px 10px',
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap={10} wrap="nowrap">
          <Image src="/images/shell-logo.svg" alt="Shell station" w={20} h={20} fit="contain" />
          <div>
            <Text size="10px" c="#94A3B8" fw={600} lh={1.2} tt="uppercase" style={{ letterSpacing: '0.04em' }}>
              Station
            </Text>
            <Text size="13px" c="#E5E7EB" fw={600} lh={1.25}>
              50 Gippsland Hwy
            </Text>
          </div>
        </Group>
        <IconChevronDown size={14} color="#94A3B8" />
      </Group>
    </UnstyledButton>
  );
};

export default WorkspaceSwitcher;
